/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertLicenseIcon16Solid = forwardRef('CertLicenseIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 3.5A2.5 2.5 0 0 1 3.5 1h9A2.5 2.5 0 0 1 15 3.5v7a2.5 2.5 0 0 1-2 2.45v2.398a.5.5 0 0 1-.765.424l-1.102-.69a.25.25 0 0 0-.265 0l-1.103.69A.5.5 0 0 1 9 15.348V13H3.5A2.5 2.5 0 0 1 1 10.5v-7Zm3 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM5.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm7.375 4a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z" })));
});
